import { TaskStatus } from 'src/graphql/types/tasks'

/** Statuses that count as an open task across filters and lists */
export const OPEN_TASK_STATUSES = [
  TaskStatus.NOT_STARTED,
  TaskStatus.IN_PROGRESS,
]

// Status → StyledBadge color, shared by the tasks table and the task modal so
// the status badge looks the same everywhere.
export const STATUS_BADGE_COLOR: Record<
  string,
  'gray' | 'blue' | 'green' | 'red'
> = {
  [TaskStatus.NOT_STARTED]: 'gray',
  [TaskStatus.IN_PROGRESS]: 'blue',
  [TaskStatus.COMPLETED]: 'green',
  [TaskStatus.CANCELLED]: 'red',
}
